"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/AutomaticIcon.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var AutomaticIcon = function AutomaticIcon(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 208.17 208.17"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Automatic Transmission Icon"), _react2.default.createElement("g", {
    className: "automatic-icon",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("g", {
    className: "circle",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "outer-circle",
    d: "M104.08 0a104.09 104.09 0 1 0 104.09 104.08A104.2 104.2 0 0 0 104.08 0zm0 198.71a94.62 94.62 0 1 1 94.62-94.62 94.73 94.73 0 0 1-94.62 94.62z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "inner-circle",
    d: "M104.08 18.45a85.63 85.63 0 1 0 85.63 85.63 85.73 85.73 0 0 0-85.63-85.63zm0 168.43a82.79 82.79 0 1 1 82.79-82.79 82.89 82.89 0 0 1-82.79 82.79z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: undefined
  })), _react2.default.createElement("path", {
    className: "letter",
    d: "M143.92 146.63H135a3.83 3.83 0 0 1-2.49-.77 4.72 4.72 0 0 1-1.43-2l-8-20.54H85l-8 20.58a4.18 4.18 0 0 1-1.37 1.9 3.79 3.79 0 0 1-2.49.83h-8.9l34-85.08h11.66zm-24-31.59l-13.34-34.62q-.6-1.54-1.25-3.59t-1.25-4.36a64.71 64.71 0 0 1-2.55 8L88.17 115h31.77z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: undefined
  })));
};
exports.default = AutomaticIcon;